module.exports = __webpack_public_path__ + "images/videoCaseStudy-viselio-challenge-videoPoster.jpg?h=cda2b6e8845fae976c452a0b0756ed5b";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/viselio/videoCaseStudy-viselio-challenge-videoPoster.jpg
// module id = 2133
// module chunks = 12 15